import type { DeviceMode } from '@vedalib/editor'
import * as R from 'ramda'

import { getNodeUsages } from 'components/Editor/EditorContext/selectors/block'
import type { Block, ElementState, IProjectContext, MapType } from 'services/Store/Project/types'

import { elementLens, elementsLens, imageObjectFitLens } from '../lenses'
import type { ICompleteElementPayload } from '../reducer'
import { getBlock, getBlockElementsState, getDeviceMode } from '../selectors'
import { updateBlockState } from './common'

export const updateElement = (id: string, state: Partial<ElementState>) =>
  R.over(elementLens(id), (old) => R.mergeRight(old, state))

export const clearElements = (ids: string[]) => R.over(elementsLens, R.omit(ids))

export const clearElementValues = (ids: string[]) =>
  R.over(elementsLens, (elements) => ({
    ...elements,
    ...R.map<MapType<ElementState>, MapType<ElementState>>(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      R.pick(['initialItems']),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      R.pick(ids, elements),
    ),
  }))

export const setImageObjectFit =
  (id: string, device: DeviceMode, value: string) => (block: Block) =>
    R.set(imageObjectFitLens(id, device), value)(block)

export const completeElementInBlock = (
  state: IProjectContext,
  payload: ICompleteElementPayload,
) => {
  const { blockId, incomplete, elementId } = payload
  const elements = getBlockElementsState(state, blockId)
  const block = getBlock(state, { id: blockId })!

  if (!block) {
    return state
  }

  const deviceMode = getDeviceMode(state)
  const { usedElements } = getNodeUsages(block, { deviceMode })
  const fullState = { ...elements, [elementId]: { incomplete } }

  const hasIncompleteElement =
    usedElements.some((el) => fullState[el.id]?.incomplete) && block.isMandatory

  return R.compose(
    updateBlockState(blockId, { incomplete: hasIncompleteElement }),
    updateElement(elementId, { incomplete }),
  )(state)
}
